<template>
    <div>
        <header>
            <el-form :inline="true" class="demo-form-inline" label-width="100px" size="small" >
                <el-form-item label="字典列表查询" >
                    <el-input clearable v-model="condition" placeholder="请输入字典" style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getData" >查询</el-button>
                    <el-button v-if="rolePermission === '领导'" type="success" @click="update">增加</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
                <el-table :data="list" height="calc(100vh - 136px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                    min-width="30px" style="font-size: 14px; flex-wrap: nowrap;  margin-top: 0px;" size="mini">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="字典值" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.value }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="字典类型"  width="auto" align="center" :filters="typeOptions" :filter-method="filterHandler"
                    column-key="type" prop="type">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-mingcheng"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.type }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-mingcheng"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.createMan }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-switch @change="changeStatus(scope.row)" v-model="scope.row.status"
                                active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button>
                            <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            <!-- 添加字典类型弹框 -->
            <div>
                <el-dialog title="添加字典信息" :close-on-click-modal="false" :show-close="false"
                    :visible.sync="dialogFormVisible">
                    <el-form :model="obj" ref="obj">
                        <el-form-item required label="字典类型">
                            <el-select filterable filterableselect style="width: 100%;" v-model="obj.type"
                                placeholder="请选择">
                                <el-option v-for="item in options" :key="item.id" :label="item.typeName"
                                    :value="item.typeName">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model.trim="obj.type" autocomplete="off"></el-input> -->
                        </el-form-item>
                        <el-form-item required label="字典值">
                            <el-input v-model="obj.value" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirmChange">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    name: 'dictionaryData',
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            null: '',
            condition: '',
            list: [],
            dialogFormVisible: false,
            obj: {
                type: '',//字典类型
                value: '',//字典值'
            },
            status: true,//状态
            options: [],//下拉框
            typeOptions:[],// 字典类型筛选

        }
    },
    mounted() {
        this.gettype()
        this.getData();
    },
    methods: {
        rowStyle() {
            return "text-align:center";
        },
        gettype(){
            let URL = `${url.getDicTypeList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    res.data.data.forEach(item => {
                        this.typeOptions.push({
                            value: item.typeName,
                            text: item.typeName
                        })
                    })
                }
            })
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        // 查询任务列表
        getData() {
            // this.currentPage = page;
            let URL = `${url.getDicList}/?value=${this.condition}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data.data;
                    this.computedStatus();
                }
            })
        },
        //计算状态
        computedStatus() {
            for (const key in this.list) {
                if (this.list[key].status === 1) {
                    this.list[key].status = true;
                } else if (this.list[key].status === 0) {
                    this.list[key].status = false;
                }
            }
            return this.list;
        },
        // 开关状态
        changeStatus(row) {
            let URL = `${url.updateStatus}/${row.id}`;
            req.put(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '变更成功!'
                    });
                    this.getData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },

        //新增
        update() {
            this.dialogFormVisible = true;
            let URL = `${url.getDicTypeList}/?name=${this.null}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.options = res.data.data;
                }
            })
        },
        //取消
        cancel() {
            this.dialogFormVisible = false;
            this.obj.type = '';
            this.obj.value = '';
        },
        //确认新增
        confirmChange() {
            if (this.obj.type === '' || this.obj.value === '') {
                this.$message({
                    type: 'error',
                    message: '请填写完整信息！'
                })
            } else {
                let URL = `${url.addDic}/`;
                req.post(URL, this.obj).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '新增成功'
                        })
                        this.getData();
                        this.obj.type = '';
                        this.obj.value = '';
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })
            }

        },
    },
}
</script>

<style lang="css" scoped>
::v-deep .el-form-item {
    margin-bottom: 10px;
}
</style>